const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const completionFields = [
  {
    id: "customer_note",
    label: "Customer Notes",
    placeHolder: "Enter customer notes",
    type: "textarea",
    md: 12,
    inputProps: {
      maxLength: 150,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    editReadOnly:true
  },
  
  {
    id: "survey_note",
    label: "Survey Notes",
    placeHolder: "Enter survey notes",
    type: "textarea",
   md: 12,
    inputProps: {
      maxLength: 150,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    editReadOnly:true
  },
  {
    id: "quote_note",
    label: "Quote Notes",
    placeHolder: "Enter quote notes",
    type: "textarea",
    md: 12,
    inputProps: {
      maxLength: 150,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    editReadOnly:true
  },
  {
    id: "confirmation_note",
    label: "Confirmation Notes",
    placeHolder: "Enter confirmation notes",
    type: "textarea",
    md: 12,
    inputProps: {
      maxLength: 150,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    editReadOnly:true
  },
    {
    id: "transport_note",
    label: "Transport Notes (Internal)",
    placeHolder: "Enter transport notes",
    type: "textarea",
    md: 12,
    inputProps: {
      maxLength: 150,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    editReadOnly:true
  },
  // {
  //   id: "crew_notes",
  //   label: "Crew Notes",
  //   placeHolder: "Enter crew notes",
  //   type: "text",
  //   md: 12,
  //   inputProps: {
  //     maxLength: 150,
  //   },
  //   patternAllowed: patternConstant?.ALPHANUMERIC,
  // },
];


  export const feedbackFields=[
    {
        id: "q1",
        label: "Q1",
        placeHolder: "Enter Q1",
        type: "text",
        // md:4.5,
        // isRequired: true,
        inputProps: {
          maxLength: 150,
        },
        patternAllowed: patternConstant?.ALPHANUMERIC
      },
      {
        id: "q1",
        label: "Ans1",
        placeHolder: "Enter Q1",
        type: "rating",
        // md:10.5,
        // isRequired: true,
        inputProps: {
          maxLength: 150,
        },
        patternAllowed: patternConstant?.ALPHANUMERIC
      },
      {
        id: "q2",
        label: "Q2",
        placeHolder: "Enter Q2",
        type: "text",
        // md:10.5,
        // isRequired: true,
        inputProps: {
          maxLength: 150,
        },
        patternAllowed: patternConstant?.ALPHANUMERIC
      },
      {
        id: "q1",
        label: "Ans2",
        placeHolder: "Enter Q1",
        type: "text",
        // md:10.5,
        // isRequired: true,
        inputProps: {
          maxLength: 150,
        },
        patternAllowed: patternConstant?.ALPHANUMERIC
      },
      {
        id: "q3",
        label: "Q3",
        placeHolder: "Enter Q3",
        type: "text",
        // md:10.5,
        // isRequired: true,
        inputProps: {
          maxLength: 150,
        },
        patternAllowed: patternConstant?.ALPHANUMERIC
      },
      {
        id: "q1",
        label: "Ans3",
        placeHolder: "Enter Q1",
        type: "text",
        // md:10.5,
        // isRequired: true,
        inputProps: {
          maxLength: 150,
        },
        patternAllowed: patternConstant?.ALPHANUMERIC
      },
      {
        id: "q4",
        label: "Q4",
        placeHolder: "Enter Q4",
        type: "text",
        // md:10.5,
        // isRequired: true,
        inputProps: {
          maxLength: 150,
        },
        patternAllowed: patternConstant?.ALPHANUMERIC
      },
      {
        id: "q1",
        label: "Ans4",
        placeHolder: "Enter Q1",
        type: "text",
        // md:10.5,
        // isRequired: true,
        inputProps: {
          maxLength: 150,
        },
        patternAllowed: patternConstant?.ALPHANUMERIC
      },
      {
        id: "q5",
        label: "Q5",
        placeHolder: "Enter Q5",
        type: "text",
        // md:10.5,
        // isRequired: true,
        inputProps: {
          maxLength: 150,
        },
        patternAllowed: patternConstant?.ALPHANUMERIC
      },
      {
        id: "q1",
        label: "Ans5",
        placeHolder: "Enter Q1",
        type: "text",
        // md:10.5,
        // isRequired: true,
        inputProps: {
          maxLength: 150,
        },
        patternAllowed: patternConstant?.ALPHANUMERIC
      },
      {
        id: "comment",
        label: "Comment Q",
        placeHolder: "Enter comment",
        type: "text",
        // md:10.5,
        // isRequired: true,
        inputProps: {
          maxLength: 150,
        },
        patternAllowed: patternConstant?.ALPHANUMERIC
      },
      {
        id: "q1",
        label: "Cooment Ans",
        placeHolder: "Enter Q1",
        type: "text",
        // md:10.5,
        // isRequired: true,
        inputProps: {
          maxLength: 150,
        },
        patternAllowed: patternConstant?.ALPHANUMERIC
      },
  ]
